import { render } from "./InterfaceShortcut.vue?vue&type=template&id=12600f45"
import script from "./InterfaceShortcut.vue?vue&type=script&lang=js"
export * from "./InterfaceShortcut.vue?vue&type=script&lang=js"

import "./InterfaceShortcut.vue?vue&type=style&index=0&id=12600f45&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__